const FIND_MY_BOOKING_BY_REFERENCE_DATA = {
  email: {
    id: "email",
    errors: {
      EMPTY: {
        track: "email_missing_error",
        key: "mytripslogin.find.booking.by.reference.error.email.empty"
      },
      FORMAT: {
        track: "email_invalid_error",
        key: "mytripslogin.find.booking.by.reference.error.email.format",
        validator: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
      }
    }
  },
  bookingReference: {
    id: "bookingReference",
    errors: {
      EMPTY: {
        track: "reference_missing_error",
        key: "mytripslogin.find.booking.by.reference.error.reference.empty"
      },
      FORMAT: {
        track: "reference_invalid_error",
        key: "mytripslogin.find.booking.by.reference.error.reference.invalid",
        validator: /^\d{10,11}$/
      }
    }
  },
  global: {
    INVALID_REQUEST: {
      track: "reference_and_email_dont_match_error",
      key: "mytripslogin.find.booking.by.reference.error.notfound"
    },
    GENERIC_ERROR: {
      track: "reference_and_email_dont_match_error",
      key: "mytripslogin.find.booking.by.reference.error.remote"
    }
  }
};
export default FIND_MY_BOOKING_BY_REFERENCE_DATA;